<script setup>
import { computed } from 'vue'
import { useTranslaterStore } from '@/stores/translater'

const translaterStore = useTranslaterStore()
const getTranslate = computed(() => translaterStore.getTranslate)

</script>

<template>
    <div class="asw-ws-indicator">
        <div class="asw-ws-indicator__container">
            <div class="asw-ws-indicator__spinner">
                <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
            <div class="asw-ws-indicator__content">
                <strong class="asw-ws-indicator__content-title">{{ getTranslate.WS_INDICATOR_TITLE }}</strong>
                <p class="asw-ws-indicator__content-text">{{ getTranslate.WS_INDICATOR_TEXT }}</p>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
@import '@/assets/styles/scss/components/ws-indicator.scss';
</style>
